import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { setTimeout, clearTimeout } from 'timers';
import ViewContainer from "./view-container";

class ContentAwareContainer extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isNearBottom: false,
			isNearBottomEventInProgress: false,
			isContentFilled: false,
			isContentFilledEventInProgress: false,
			measuredHeight: 0
		};

		this.executeThenSetState = this.executeThenSetState.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.handleResize = this.handleResize.bind(this);
		this.updateHeight = this.updateHeight.bind(this);
		this.executeOnNearBottom = this.executeOnNearBottom.bind(this);
        this.getNearBottomFunc = this.getNearBottomFunc.bind(this);
        this.setNearBottomState = this.setNearBottomState.bind(this);
	}

	componentDidMount() {
		this.updateHeight();
		window.addEventListener('resize', this.handleResize);

		this.targetElement = document.getElementById('content-layout');
		if (!this.targetElement) return;
		this.targetElement.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);

		if (!this.targetElement) return;
		this.targetElement.removeEventListener('scroll', this.handleScroll);
	}

	componentWillUpdate() {}

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.isContentFilled && this.state.isContentFilled) {
			this.executeOnNearBottom();
			return;
		}

		if (!prevState.isNearBottom && this.state.isNearBottom) {
			this.executeOnNearBottom();
			return;
		}

		if (this.props.conditionIsSatified) {
			return;
		}

		if (this.state.isNearBottom &&  !this.props.conditionIsSatified && this.props.onNearBottom) {
			this.executeOnNearBottom();
			return;
		}

		if (!this.targetElement) return;

		const contentHeightInContainer =
			this.targetElement.offsetParent &&
			this.targetElement.offsetParent.scrollHeight -
				(this.targetElement.scrollHeight - this.targetElement.scrollTop) -
				100;

		if (contentHeightInContainer > 0) {
			//content filled
			if (!this.state.isContentFilled) {
				this.executeOnNearBottom();
			}
		}
	}

	executeOnNearBottom() {
		if (this.nearBottomTimerToken) {
			clearTimeout(this.nearBottomTimerToken);
			this.nearBottomTimerToken = null;
		}
		this.nearBottomTimerToken = setTimeout(() => {
			if (!this.props.conditionIsSatified) {
				this.props.onNearBottom();
			}
		}, 50);
	}

	handleScroll() {
		//store these values; we can't be sure when this will execute;
		requestAnimationFrame(this.updateHeight);

		if (!this.targetElement) return;

		const scrollHeight = this.targetElement.scrollHeight;
		const scrollTop = this.targetElement.scrollTop;
		const offsetHeight = this.targetElement.offsetHeight;
		const nearBottomFunc = this.getNearBottomFunc(this,scrollHeight,scrollTop,offsetHeight);
		requestAnimationFrame(nearBottomFunc);
	}
	getNearBottomFunc(_self,scrollHeight,scrollTop, offsetHeight){
		return function(){ _self.setNearBottomState(_self,scrollHeight,scrollTop,offsetHeight)}
	}
	setNearBottomState(_self,scrollHeight, scrollTop, offsetHeight){
        const distanceFromBottom = scrollHeight - scrollTop - offsetHeight;
        if (distanceFromBottom < 100) {
            _self.setState({ isNearBottom: true });
        } else {
            _self.setState({ isNearBottom: false });
        }
	}

	handleResize() {
		requestAnimationFrame(this.updateHeight);
	}

	updateHeight() {
		if (!this.props.computeHeight) return;
		if (!this.targetElement) return;

		const measuredHeight = window.innerHeight - 100;
		const isContentFilled = this.targetElement.clientHeight >= measuredHeight;
		this.setState({
			measuredHeight: measuredHeight,
			isContentFilled: isContentFilled
		});
	}

	executeThenSetState(functionToExecute, stateOnSuccess, stateOnError, finalState) {
		(async () => {
			try {
				await functionToExecute();
				if (stateOnSuccess) {
					this.setState(stateOnSuccess);
				}
			} catch (error) {
				if (stateOnError) {
					this.setState(stateOnError);
				}
			} finally {
				if (finalState) {
					this.setState(finalState);
				}
			}
		})();
	}

	getDisplayName() {
		return 'ContentAwareContainer';
	}

	render() {
		const containerStyle = {};
		if (this.state.measuredHeight) {
			containerStyle.height = this.state.measuredHeight;
		}
		return (
			<ViewContainer title={this.props.title} description={this.props.description} className={this.props.className} ref={thisContainer => (this.container = thisContainer)}
                           style={containerStyle}>
				{this.props.children}
			</ViewContainer>
		);
	}
}

ContentAwareContainer.propTypes = {
	onNearBottom: PropTypes.func.isRequired,
	onNoLongerNearBottom: PropTypes.func, //TODO: Fix these names.
	onContentNotFilled: PropTypes.func,
	onContentFilled: PropTypes.func,
	// children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
	className: PropTypes.string,
	conditionIsSatified: PropTypes.bool,
	title: PropTypes.any,
	computeHeight: PropTypes.bool
};

ContentAwareContainer.defaultProps = {
	computeHeight: true
};

export default ContentAwareContainer;



// WEBPACK FOOTER //
// ./src/common/components/content-aware-container.jsx